/**
 * This panel user's own state for a thread or chat row (2026-10-16): "Yangi"
 * when they have never opened it, otherwise the number of messages since
 * they last looked. Theirs alone -- it is not the participants' read state.
 */
const SeenPill = ({ row }) => {
  if (row.seen_is_new) return <span className="ms-new-pill">Yangi</span>;
  const n = row.seen_new_count || 0;
  if (n <= 0) return null;
  return (
    <span className="ms-count-pill" title={`${n} ta yangi xabar`}>
      {n > 99 ? "99+" : n}
    </span>
  );
};

/** For the row's className: bold and tinted while there is something unseen. */
export const unseen = (row) => Boolean(row.seen_is_new || row.seen_new_count > 0);

export default SeenPill;
